import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const setupStoreLandingRoutes = {
  name: 'store-landing',
  path: 'setup/store-landing',
  component: () => import('./SetupStoreLanding.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
